import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { flexDirection: string; loading: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      margin: [18, 0, 40, 0],
      width: '100%',
      maxWidth: '684px',
      backgroundColor: 'var(--x-bg-1)',
      padding: [16, 12, 32],
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 8,
      [mediaQuery(breakpoints.tablet)]: {
        maxWidth: '100%',
      },
    },
    image: {
      width: 84,
      height: 84,
    },
    text: {
      color: 'var(--x-text-color-6)',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: FontWeight.SemiBold,
      textAlign: 'center',
    },
  }),
  { name: 'empty-results' },
);
export default useStyles;
